//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vueQR from '~/components/common/vueQR.vue'
export default {
  components: {
    'vue-qr': vueQR
  },
  data () {
    return {
      qrUrl: '', // 二维码地址
      qrToken: '', // 二维码token
      qrScanSucc: false, // 是否扫码成功
      refreshQR: false, // 是否刷新二维码
      websock: null // WebSocket配置项
    }
  },
  computed: {
    // 面包屑导航——首页
    breadHost () {
      return this.$store.getters.breadHome
    },
    // 完整的域名
    fullDomain () {
      return this.$store.state.fullHost
    }
  },
  mounted () {
    this.qrTokenFn() // 获取二维码
  },
  beforeDestroy () {
    this.websock?.close()
    this.websock = null
    clearTimeout(this.qrTimer) // 清除延时器
    clearTimeout(this.heartTimer)
  },
  methods: {
    // 二维码登录——获取二维码内容
    async qrTokenFn () {
      this.refreshQR = this.qrScanSucc = false // 刷新二维码前的操作
      clearTimeout(this.qrTimer)
      try {
        const { result = {} } = await this.$api.login.userGetqrcode()
        const { Token: token = '', WikiQRType: qrType = '' } = result?.WikiFXQR || {}
        this.qrToken = token
        const { isChina = false, countryCode = '' } = this.$store.state
        this.qrUrl = (isChina ? `https://m${this.$store.getters.halfHost}/download.html` : 'https://apphtml.0067.cc/mobile/download') + `?languageCode=${this.currLangCode()}&countryCode=${countryCode}&qrid=${token}&type=${qrType}&app=usersite`
        if (!this.websock) this.initWebSocket() // 初始化WebSocket
        this.qrTimer = setTimeout(() => { // 一分钟后二维码失效
          clearTimeout(this.qrTimer)
          this.refreshQR = true
        }, 60000)
      } catch (err) {}
    },
    // WebSocket初始化
    initWebSocket () {
      this.websock = new WebSocket('wss://websocket.interface003.com')
      this.websock.onopen = () => {
        this.websock.send(JSON.stringify({ WikiFXQR: { Token: this.qrToken } }))
        this.heartTimer = setTimeout(this.heartBeat, 10000) // 开启心跳连接
      }
      this.websock.onerror = () => {
        this.reconnect() // 重新连接
      }
      this.websock.onmessage = (e = '') => {
        if (!e || !e.data) return false
        if (e.data == 1) { // 扫码成功
          this.refreshQR = false
          this.qrScanSucc = true
        } else if (e.data == 2) { // 取消授权
          this.qrScanSucc = false
          this.refreshQR = true
        } else this.getUCookie(e.data) // 获取登录信息
      }
    },
    // WebSocket心跳连接
    heartBeat () {
      clearTimeout(this.heartTimer)
      if (this.websock?.readyState == 1) this.websock.send('123456') // 连接正常
      else this.reconnect() // 连接异常，重新连接
      this.heartTimer = setTimeout(this.heartBeat, 10000)
    },
    // WebSocket重新连接
    reconnect () {
      clearTimeout(this.heartTimer)
      if (this.lockReconnect) return false
      this.lockReconnect = true
      const sockTime = setTimeout(() => { // 没连接上会一直重连，设置延迟避免请求过多
        clearTimeout(sockTime)
        this.initWebSocket()
        this.lockReconnect = false
      }, 2000)
    },
    // 获取用户信息
    async getUCookie (obj = {}) {
      const { countryCode = '' } = this.$store.state
      if (typeof obj != 'object') {
        try {
          const { result = {} } = await this.$api.login.getUserInfoClient({ UserId: obj, ApplicationType: 7, CountryCode: countryCode, LanguageCode: this.currLangCode(), Ppl: 7, Poy: 1 })
          this.accessCookie(result || {})
        } catch (err) {}
      }
    },
    // 加密cookie
    async accessCookie (obj = {}) {
      const { userId = '', nick = '', showNickName = '', avatar = '', showAvataraddress = '' } = obj || {}
      try {
        const { succeed = false, extra = '', result = {} } = await this.$api.login.userEncryption({ userId, nick: showNickName || nick, avatar: showAvataraddress || avatar })
        if (!succeed) return this.$toast.error(extra) // 数据错误
        this.$store.commit('setVal', { cookieVal: result?.Value, simpleUser: { userId, nick: showNickName || nick, avatar: showAvataraddress || avatar } })
        if (this.fullDomain?.includes('wikifx')) this.setCookie('DJkdikKMG', result?.Value, this.$store.getters.cookConf)
        else if (this.fullDomain?.includes('fxeye')) this.setCookie('ViLartidlakd', result?.Value, this.$store.getters.cookConf)
        else {
          this.$cookies.set('WsdsfgDGdagYms', result?.Value)
          const postdata = { op_type: 'setCookie', url: '', parm: result?.Value }
          window?.parent?.postMessage(postdata, '*')
        }
        this.$emit('close')
      } catch (err) {}
    },
    // 存储cookie
    setCookie (key = '', val = '') {
      this.$cookies.set(key, val, this.$store.getters.cookConf)
    }
  }
}
